import { Button, ButtonVariant } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'
import { type UpdateEmailStep, UpdateEmailField } from '../../types/email/email-types'

export const ConfirmEmailStep: FC<UpdateEmailStep> = ({ closeModal }) => {
  const { t } = useTranslation('features-settings')

  const { getValues } = useFormContext()

  const email = getValues(UpdateEmailField.EMAIL) as string

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4 items-center">
        <CheckCircleIcon height="17" width="17" className="fill-green-400" />
        <p className="text-textSuccess fs-exclude">{email}</p>
      </div>
      <Button variant={ButtonVariant.Primary} id="doneUpdateEmail" onClick={closeModal}>
        {t('settings.personal_info.change.done')}
      </Button>
    </div>
  )
}
